// ─── SVG 도넛 차트 ────────────────────────────────────────────────────────────
import React from 'react';

export default function DonutChart({ segs, size = 140 }) {
  const total = segs.reduce((s, x) => s + x.value, 0);
  if (!total)
    return <p className="py-8 text-center text-sm text-gray-400">데이터 없음</p>;

  const cx = size / 2, cy = size / 2;
  const R = size / 2 - 10, ri = R * 0.60;
  const nonZero = segs.filter((s) => s.value > 0);

  let paths;
  if (nonZero.length === 1) {
    paths = [{ ...nonZero[0], isFull: true }];
  } else {
    let ang = -Math.PI / 2;
    paths = nonZero.map((seg) => {
      const a  = (seg.value / total) * Math.PI * 2;
      const sa = ang, ea = ang + a;
      ang = ea;
      const la = a > Math.PI ? 1 : 0;
      const d = [
        `M ${(cx + R * Math.cos(sa)).toFixed(2)} ${(cy + R * Math.sin(sa)).toFixed(2)}`,
        `A ${R} ${R} 0 ${la} 1 ${(cx + R * Math.cos(ea)).toFixed(2)} ${(cy + R * Math.sin(ea)).toFixed(2)}`,
        `L ${(cx + ri * Math.cos(ea)).toFixed(2)} ${(cy + ri * Math.sin(ea)).toFixed(2)}`,
        `A ${ri} ${ri} 0 ${la} 0 ${(cx + ri * Math.cos(sa)).toFixed(2)} ${(cy + ri * Math.sin(sa)).toFixed(2)}`,
        'Z',
      ].join(' ');
      return { ...seg, d };
    });
  }

  return (
    <div className="flex flex-col items-center gap-4">
      {/* 도넛 SVG */}
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        {paths.map((p, i) =>
          p.isFull ? (
            <g key={i}>
              <circle cx={cx} cy={cy} r={R}  fill={p.color} />
              <circle cx={cx} cy={cy} r={ri} fill="white"   />
            </g>
          ) : (
            <path key={i} d={p.d} fill={p.color} />
          )
        )}
        <text x={cx} y={cy - 6}  textAnchor="middle" fontSize="22" fontWeight="bold" fill="#1e293b">{total}</text>
        <text x={cx} y={cy + 13} textAnchor="middle" fontSize="12" fill="#94a3b8">전체</text>
      </svg>

      {/* 범례 */}
      <div className="w-full space-y-2">
        {segs.map((s, i) => (
          <div key={i} className="flex items-center justify-between gap-3">
            <div className="flex items-center gap-2">
              <div
                className="rounded-sm shrink-0"
                style={{ width: '12px', height: '12px', backgroundColor: s.color }}
              />
              <span className="text-sm text-gray-600">{s.label}</span>
            </div>
            <span className="text-sm font-semibold font-mono text-gray-800">
              {s.value}
              <span className="ml-1 font-normal text-gray-400">
                ({((s.value / total) * 100).toFixed(0)}%)
              </span>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
